import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

const Layout = () => {
    return (
        <div className="min-h-screen bg-neutral-100 flex justify-center px-4 py-8">
            <div className="w-full max-w-7xl bg-white shadow-md border border-gray-200 flex flex-col">
                <Header />
                <main className="flex-grow p-6">
                    <Outlet />
                </main>
                <Footer />
            </div>
        </div>
    );
};

export default Layout;